import Flag from "./SVG/flag.svg?react";

const FlagIcon = () => {
  return <Flag />;
};

export default FlagIcon;
